import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, ClipboardCheck, Loader2 } from "lucide-react";
import { maintenanceApi } from "@/services/api";
import { apiError } from "@/lib/format";
import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { toast } from "sonner";

export function ReinspectionPrompt({ jobId, doorId, doorRef, open, onOpenChange, onDone }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const inspectNow = () => {
    onOpenChange(false);
    navigate(`/inspections/new?doorId=${doorId}`);
  };

  const requestInspector = async () => {
    setBusy(true);
    try {
      await maintenanceApi.requestReinspection(jobId);
      toast.success("Inspector requested — added to the re-inspection queue");
      onOpenChange(false);
      onDone?.();
    } catch (e) {
      toast.error(apiError(e, "Could not request inspector"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="reinspection-prompt">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ShieldCheck className="h-5 w-5 text-primary" /> Post-work re-inspection needed
          </DialogTitle>
          <DialogDescription>
            The remedial works are complete{doorRef ? ` on ${doorRef}` : ""}. This door needs a fire-door
            re-inspection. Inspect it now, or hand it to the inspection team.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2 pt-1">
          <Button onClick={inspectNow} disabled={busy} data-testid="reinspect-inspect-now">
            <ClipboardCheck className="mr-2 h-4 w-4" /> Inspect it now
          </Button>
          <Button variant="outline" onClick={requestInspector} disabled={busy} data-testid="reinspect-request-inspector">
            {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <ShieldCheck className="mr-2 h-4 w-4" />} Request an inspector
          </Button>
          <Button variant="ghost" size="sm" onClick={() => onOpenChange(false)} disabled={busy} data-testid="reinspect-dismiss">
            Not now
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
